/*
 * The 6A first run: what a new free-event account lands on. It has no
 * channel yet, so the empty Channels page becomes one calm card with
 * "Create channel", the finished ticket beside it, and two short cards on
 * the iPad and on what guests get. The start rule is said once, in the
 * banner above.
 */
import React from "react";
import { Link } from "react-router-dom";
import { CheckIcon, DeviceTabletIcon } from "@heroicons/react/24/solid";
import { ft, fw, Photo, Ticket, STAMPS } from "./index";

const STEPS = ["fr.s1", "fr.s2", "fr.s3"];

const FirstRun = ({ firstName, email, company }) => (
  <div className="mb-fs first-run">
    <div className="first-wrap">
      <section className="first" aria-labelledby="fr-h">
        <div className="fcopy">
          <Photo slot="guest-hero" className="fphoto" />
          <p className="hi">{firstName ? ft("to.new.b", { first_name: firstName }) : ft("to.new.b0")}</p>
          <h2 id="fr-h">{fw("fr.h")}</h2>
          <p className="fp">{fw("fr.p")}</p>
          <Link className="btn" to="/channels/new">
            {ft("fr.btn")}
          </Link>
        </div>
        <ol>
          <li className="done">
            <i>
              <CheckIcon className="ic" aria-hidden="true" />
            </i>
            {ft("fr.s0")}
          </li>
          {STEPS.map((k, n) => (
            <li key={k} className={n === 0 ? "now" : ""} aria-current={n === 0 ? "step" : undefined}>
              <i>{n + 2}</i>
              {ft(k)}
            </li>
          ))}
        </ol>
      </section>
      <div className="tkc" aria-hidden="true">
        <Ticket stamps={STAMPS.done} title={company ? ft("t.host", { company }) : ft("t.h")} />
      </div>
    </div>
    <div className="fmore">
      <section className="fcard">
        <DeviceTabletIcon className="ic" aria-hidden="true" />
        <div>
          <b>{ft("fr.ipad.h")}</b>
          <p>{fw("fr.ipad", { email: email || "" })}</p>
        </div>
      </section>
      <section className="fcard">
        <div className="fprints" aria-hidden="true">
          <Photo slot="guest-group" />
          <Photo slot="guest-solo-c" />
          <Photo slot="guest-solo-b" />
        </div>
        <div>
          <b>{ft("fr.guest.h")}</b>
          <p>{fw("fr.guest")}</p>
        </div>
      </section>
    </div>
  </div>
);

export default FirstRun;
